<template>    
<div v-if="coverageState">
  <v-menu v-model="showMenu" 
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
    >
    <v-list subheader>
       <v-subheader>{{$t('Pilot.Tools.Title')}}<v-spacer /><v-icon>mdi-group</v-icon></v-subheader>                     
       <v-list-tile @click="showGlobalWaypoint()">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-plus</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Simulation.AddGlobalPoint')}}</v-list-tile-title>                
      </v-list-tile>                        
      <v-list-tile v-if="hasGrid && isDeploymentCommon" @click="changeDrawMode('DEPLOYMENT')">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-down</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Simulation.WptDeployment')}}</v-list-tile-title>      
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="drawMode=='DEPLOYMENT'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>          
      </v-list-tile>                
      <v-list-tile v-if="hasGrid && isRecoveryCommon"  @click="changeDrawMode('RECOVERY')">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-remove-variant</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Simulation.WptRecovery')}}</v-list-tile-title>      
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="drawMode=='RECOVERY'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>          
      </v-list-tile>                
      <v-list-tile   @click="changeDrawMode('wpt')">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-plus</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Simulation.AddPoint')}}</v-list-tile-title>      
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="drawMode=='wpt'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>          
      </v-list-tile>                
    </v-list>        
    <slot></slot>
  </v-menu>     
</div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { MissionPlanUiState } from '../../models/ui/MissionPlanUiState'
import { CoverageUiState } from '@/models/ui/CoverageUiState'
import { Watch } from 'vue-property-decorator/lib'

@Component({
  name: 'MapCoverageContextMenu',
  props:{
    coverageState:{
        type: Object,
        required: true
    }
  }
})
export default class MapCoverageContextMenu extends Vue {
    coverageState!:CoverageUiState
    showMenu = false
    x = 0
    y = 0    

    get drawMode() { return this.coverageState.drawMode } 
    set drawMode(value){ 
      //s'assure que les outils de mesure soit a null
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      this.$nextTick(()=>{
        this.coverageState.drawMode=value
      })      
    }

    get showGlobalWpts() { return this.coverageState.showGlobalWpts }
    set showGlobalWpts(value){ this.coverageState.showGlobalWpts=value}
    

    show (e:any) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    }   
     
    showGlobalWaypoint() {      
      this.showGlobalWpts = true
    }

    changeDrawMode(mode:string){  
      this.cancelWaypoint()
      this.$nextTick(() => {this.drawMode= this.drawMode==mode?"":mode})     
    }

    cancelWaypoint() {
      this.coverageState.currentEditWpt = MissionPlanUiState.getDefaultWayPoint() 
      this.coverageState.hoverWptKey = ''
    }  

    get refreshMesureTool() { return this.$store.myGetters.refreshMesureTool}
    @Watch('refreshMesureTool')
    onRefreshMesureTool(newValue:boolean){    
      this.coverageState.drawMode=""
    }

    get modified(){
      return this.$store.myGetters.modifiedAdmMissionGlobal
    }
    
    get isDeploymentCommon(){
      //@ts-ignore
      return this.modified?.config?.deployment_mode == 'common'
    }

    get isRecoveryCommon(){
      //@ts-ignore
      return this.modified?.config?.recovery_mode == 'common'      
    }

    get hasGrid(){
      return this.modified?.resultGridJson?.wpts?.length
    }
        
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style> 
